import { Flex, Text } from "styles/utility-components";

import SegmentedControl from "components/ui/segmented_control/SegmentedControl";
import {
  TOKEN_ENDPOINT_AUTH_METHOD_LABELS,
  TOKEN_ENDPOINT_AUTH_METHODS,
  type TokenEndpointAuthMethod,
} from "lib/hooks/api/auth/mcp/schemas";

const OPTIONS = TOKEN_ENDPOINT_AUTH_METHODS.map((method) => ({
  value: method,
  label: TOKEN_ENDPOINT_AUTH_METHOD_LABELS[method],
}));

type Props = {
  value: TokenEndpointAuthMethod;
  onChange: (value: TokenEndpointAuthMethod) => void;
};

/** Picks how the tool sends its client secret when it asks for a token. */
export function AuthMethodField({ value, onChange }: Props) {
  return (
    <Flex column gap={6}>
      <Text>Client authentication</Text>
      <div>
        <SegmentedControl
          aria-label="Client authentication"
          value={value}
          onChange={onChange}
          options={OPTIONS}
        />
      </div>
      <Text description>
        Choose how your tool sends the client secret when it signs in. Most tools send it in the
        request header (client_secret_basic), but some, including Microsoft Copilot Studio, send it
        in the request body (client_secret_post). If sign-in fails with an "invalid client" error,
        try the other option.
      </Text>
    </Flex>
  );
}
